window.theme = window.theme || {};
class Wishlist extends HTMLElement {
  constructor(newList, wishListItem) {
    super();

    this.customer = this.dataset.customer;
    this.sectionId = this.dataset.sectionId;
    this.customerId = this.dataset.customerId;
    this.productHandle = this.dataset.productHandle;
    this.favoriteButton = this.querySelectorAll(".wishlist-add__button");
    this.listCreate = this.querySelector(".list-create");
    this.listUpdate = this.querySelectorAll(".button-list__update");
    this.variantId = this.dataset.selectedVariantId;
    this.variantTitle = this.dataset.selectedVariantTitle;
    this.productTitle = this.dataset.selectedProductTitle;

    this.modalInit = true;
    if (this.customer == "true") {
      this.fetchWishlistItems();
    }
    this.initWishilistLists();
    if (newList) {
      this.wishlistAdd(newList);
    }
    if (wishListItem) {
      this.fetchWishlistItems(wishListItem);
    }
  }

  initWishilistLists() {
    let thisElement = this;
    let popupOverlay = document.querySelector(".modal-popup__overlay");
    let popupOverlayclose = document.querySelector(".modal-popup__overlay");
    if (this.listCreate) {
      let popupElement = document.querySelector(".create-list-modal__popup");
      if (popupElement) {
        this.listCreate.addEventListener("click", function (button) {
          let isProduct = thisElement.dataset.isProduct;
          let productTitle = thisElement.dataset.selectedProductTitle;
          if (productTitle) {
            popupElement.setAttribute("data-product-title", productTitle);
          } else {
            popupElement.removeAttribute("data-product-title");
          }
          if (isProduct == "true") {
            let variantId = thisElement.dataset.selectedVariantId;
            let variantTitle = thisElement.dataset.selectedVariantTitle;
            popupElement.setAttribute("data-variant-id", variantId);
            popupElement.setAttribute("data-variant-title", variantTitle);
          } else {
            popupElement.removeAttribute("data-variant-id");
            popupElement.removeAttribute("data-variant-title");
          }
          popupElement.classList.add("active");
          popupElement.setAttribute("data-customer-id", thisElement.customerId);
          popupElement.setAttribute("data-product-handle", thisElement.dataset.productHandle);
          thisElement.querySelector(".menu-list__item").classList.remove("show_list");
        });
        if (popupOverlay) {
          popupOverlay.addEventListener("click", function (event) {
            popupElement.classList.remove("active");
          });
        }
      }
    }
    if (this.favoriteButton) {
      let bodyshow = document.body;
      this.favoriteButton.forEach(function (button) {
        button.addEventListener("click", function () {
          let productHandle = thisElement.dataset.productHandle;
          if (thisElement.customer == "false") {
            window.location.href = FoxTheme.routes.account_login_url;
            return false;
          }
          if (button.dataset.type == "list") {
            document.querySelectorAll('.menu-list__item.show_list, .wishlist-add__button[data-type="list"].active').forEach((item) => {
              if (!thisElement.contains(item)) {
                item.classList.remove(
                  item.classList.contains("show_list") ? "show_list" : "active"
                );
              }
            });
            button.classList.toggle("active");
            thisElement.querySelector(".menu-list__item").classList.toggle("show_list");
            return false;
          }
          let listObject = [
            {
              listName: "Favorites",
              customerId: thisElement.customerId,
              productHandle: productHandle,
              type: "",
            },
          ];
          thisElement.wishlistAdd(listObject);
        });
        if (popupOverlayclose) {
          popupOverlayclose.addEventListener("click", function (event) {
            if (button.dataset.type == "list") {
              button.classList.remove("active");
            }
          });
        }
      });
      bodyshow.addEventListener("click", function (event) {
        let isClickInside =
          event.target.closest('.wishlist-add__button[data-type="list"]') ||
          event.target.closest(".menu-list__item");
        if (!isClickInside) {
          let menuListItem = document.querySelectorAll(".menu-list__item");
          menuListItem.forEach((itemList) => {
            itemList.classList.remove("show_list");
          });
          let wishlistButton = document.querySelector('.wishlist-add__button[data-type="list"].active');
          if (wishlistButton) {
            wishlistButton.classList.remove("active");
          }
        }
      });
    }
    if (this.listUpdate) {
      this.listUpdate.forEach(function (button) {
        button.addEventListener("click", function () {
          let dataType = button.dataset.type;
          let listInputElement = thisElement.querySelectorAll(
            ".input-checkbox_field"
          );
          if (dataType == "cancel") {
            listInputElement.forEach(function (listInput) {
              if (listInput.checked && listInput.dataset.checked != "true") {
                listInput.checked = false;
              } else if (!listInput.checked && listInput.dataset.checked != "false") {
                listInput.checked = true;
              }
            });
            thisElement.querySelector(".menu-list__item").classList.remove("show_list");
            thisElement.querySelector(".wishlist-action__buttons").classList.remove("active");
          } else if (dataType == "save") {
            let listObject = [];
            let checkVariantid = thisElement.getAttribute('data-selected-variant-id');
            let variantTitle = thisElement.getAttribute('data-selected-variant-title');
            let productTitle = thisElement.getAttribute('data-selected-product-title');
            let loaderButton = thisElement.querySelector(".wishlist-loader");
            loaderButton.classList.add("is-loading");
            listInputElement.forEach(function (listInput) {
              if (listInput.classList.contains("isEvent")) {
                listObject.push({
                  listName: listInput.value,
                  customerId: thisElement.customerId,
                  productHandle: thisElement.dataset.productHandle,
                  type: "",
                  variantId: checkVariantid ? checkVariantid : null,
                  variantTitle: variantTitle ? variantTitle : null,
                  productTitle: productTitle ? productTitle : null,
                });
              }
            });
            if (listObject.length) {
              thisElement.wishlistAdd(listObject);
            }
          }
        });
      });
    }
  }

  listInputChange() {
    let thisElement = this;
    let wishlistListItem = this.querySelector(".item-list_show");
    if (wishlistListItem) {
      let listInputElement = this.querySelectorAll(".input-checkbox_field");
      if (listInputElement.length) {
        listInputElement.forEach(function (input) {
          input.addEventListener("change", function () {
            let listChange = false;
            listInputElement.forEach(function (listInput) {
              if ((listInput.checked && listInput.dataset.checked !== "true") || (!listInput.checked && listInput.dataset.checked !== "false")) {
                listInput.classList.add("isEvent");
                listChange = true;
              } else {
                listInput.classList.remove("isEvent");
              }
            });
            if (listChange) {
              thisElement.querySelector(".wishlist-action__buttons").classList.add("active");
            } else {
              thisElement.querySelector(".wishlist-action__buttons").classList.remove("active");
            }
          });
        });
      }
    }
  }

  wishlistAdd(listObject) {
    let thisMainElement = this;
    let thisElement = listObject.type == "create" ? document.querySelector('wishlist-king[data-product-handle="' + listObject.productHandle + '"]') : this;
    let data = listObject;

    fetch("https://mahacotizador.com/wishlist-app/index.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then((response) => response.text()).then((responseData) => {
      let dataObject = JSON.parse(responseData);
      return thisMainElement.fetchAllWishlistData().then(() => dataObject);
    }).then((dataObject) => {
      let loaderRemove = document.querySelector(".wishlist-loader.is-loading");
      if (loaderRemove) {
        loaderRemove.classList.remove("is-loading");
      }
      let wishlistMessage = document.querySelector(".show_wishlist_message");
      let wishlistElements = document.querySelectorAll('wishlist-king[data-product-handle="' + thisElement.productHandle + '"]');
      if (dataObject.type == "error") {
        alert(dataObject.message);
        return false;
      }
      if (dataObject.type == "added") {
        // thisElement.querySelector(".wishlist-add__button.heart-favorites").classList.add("active");
        // thisElement.querySelector('.input-checkbox_field[value="Favorites"]').checked = true; 
        if (wishlistMessage) {
          wishlistMessage.textContent = dataObject.message;
          wishlistMessage.classList.add("show_message");
          if (wishlistElements && wishlistElements.length > 1) {
            wishlistElements.forEach(function (item) {
              thisElement.fetchWishlistItems(item);
            });
          } else {
            thisElement.fetchWishlistItems(thisElement);
          }
          thisElement.querySelector(".list_type.active")?.classList.remove("active");
          thisElement.querySelector(".menu-list__item.show_list")?.classList.remove("show_list");
          thisElement.querySelector(".wishlist-action__buttons.active")?.classList.remove("active");
          setTimeout(() => {
            wishlistMessage.classList.remove("show_message");
          }, 3000);
        }
      } else if (dataObject.type == "removed") {
        if (window.location.href.indexOf("pages/wishlist-list") > -1) {
          wishlistPageInit();
          return;
        }
        thisElement.querySelector(".wishlist-add__button.heart-favorites").classList.remove("active");
        //thisElement.querySelector('.input-checkbox_field[value="Favorites"]').checked = false;
        if (wishlistMessage) {
          wishlistMessage.textContent = dataObject.message;
          wishlistMessage.classList.add("show_message_remove");
          if (wishlistElements && wishlistElements.length > 1) {
            wishlistElements.forEach(function (item) {
              thisElement.fetchWishlistItems(item);
            });
          } else {
            thisElement.fetchWishlistItems(thisElement);
          }
          thisElement.querySelector(".list_type.active")?.classList.remove("active");
          thisElement.querySelector(".menu-list__item.show_list")?.classList.remove("show_list");
          thisElement.querySelector(".wishlist-action__buttons.active")?.classList.remove("active");
          setTimeout(() => {
            wishlistMessage.classList.remove("show_message_remove");
          }, 3000);
        }
      } else if (dataObject.type == "created") {
        if (window.location.href.indexOf("pages/wishlist-list") > -1) {
          window.location.reload();
        }
        let popupElement = document.querySelector(".create-list-modal__popup");
        if (popupElement) {
          popupElement.classList.remove("active");
          popupElement.querySelector(".create-modal-popup").classList.add("disabled");
          popupElement.querySelector(".modal_input").value = "";
        }
        if (wishlistMessage) {
          wishlistMessage.textContent = dataObject.message;
          wishlistMessage.classList.add("show_message_remove");
          setTimeout(() => {
            wishlistMessage.classList.remove("show_message_remove");
          }, 3000);
        }
        let wishlistItems = document.querySelectorAll("wishlist-king");
        if (wishlistItems) {
          wishlistItems.forEach(function (item) {
            thisElement.fetchWishlistItems(item);
            item.querySelector(".list_type.active")?.classList.remove("active");
            item.querySelector(".menu-list__item.show_list")?.classList.remove("show_list");
            item.querySelector(".wishlist-action__buttons.active")?.classList.remove("active");
          });
        }
      } else if (dataObject.type == "updated") {
        if (wishlistMessage) {
          wishlistMessage.textContent = dataObject.message;
          wishlistMessage.classList.add("show_message_remove");
          if (wishlistElements && wishlistElements.length > 1) {
            wishlistElements.forEach(function (item) {
              thisElement.fetchWishlistItems(item);
            });
          } else {
            thisElement.fetchWishlistItems(thisElement);
          }
          thisElement.querySelector(".list_type.active")?.classList.remove("active");
          thisElement.querySelector(".menu-list__item.show_list")?.classList.remove("show_list");
          thisElement.querySelector(".wishlist-action__buttons.active")?.classList.remove("active");
          setTimeout(() => {
            wishlistMessage.classList.remove("show_message_remove");
          }, 3000);
        }
      } else if (dataObject.type == "deleted") {
        window.location.reload();
      }
    })
      .catch((error) => {
        console.log(error);
        // alert("There was an error sending the data. Please try again.");
      });
  }

  fetchAllWishlistData() {
    let customerId = document.body.dataset.customerId;
    return fetch("https://mahacotizador.com/wishlist-app/fetch-wishlist-data.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ customerId: customerId })
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (!document.getElementById('wishlist-data')) {
          document.body.insertAdjacentHTML('beforeend', `<script id="wishlist-data" type="application/json">${JSON.stringify(data)}</script>`);
        } else {
          document.getElementById('wishlist-data').innerHTML = JSON.stringify(data);
        }
        let dataAppendDiv = document.querySelector(".nav-wishlist-list__data");
        const listNames = data.map(item => item.list_name).filter(name => name);
        if (listNames.length > 0 && dataAppendDiv) {
          let appendData = '';
          // console.log('appendData', appendData)
          listNames.forEach(function (item) {
            appendData += `<li class="site-nav__dropdown-link eee tmenu_item_content_alignment_left"><a href="/pages/wishlist-list?${item}">${item}</a></li>`;
          });
          if (appendData) {
            dataAppendDiv.innerHTML = appendData;
           setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        }
        return true;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        alert("There was an error fetching the data. Please try again.");
      });
  }

  fetchWishlistItems(item) {
    let thisElement = item ? item : this;
    let wishlistData = document.getElementById('wishlist-data')?.innerHTML;
    let selectedVariantId = thisElement.dataset.selectedVariantId;
    let productHandle = selectedVariantId ? thisElement.dataset.productHandle + '__' + selectedVariantId : thisElement.dataset.productHandle;
    wishlistData = JSON.parse(wishlistData);

    const wishlistObject = wishlistData.map(item => {
      const productHandles = JSON.parse(item.product_handle); // Parse the product_handle JSON string
      let exists = false;
      let variantId = "";
      for (const key in productHandles) {
        if (key === productHandle) {
          exists = true;
          variantId = productHandles[key].variantId;
          break;
        }
      }
      return {
        listName: item.list_name,
        productHandle: productHandle,
        exists: exists,
        variantId: variantId
      };
    });
    let checkProduct = false;
    if (thisElement.dataset.isProduct && thisElement.dataset.isProduct == 'true') {
      checkProduct = true;
    }
    if (wishlistObject.length > 0) {
      let listAppend = "";
      const hasFavorites = wishlistObject.some(item => item.listName === "Favorites");
      // if(!hasFavorites){
      //   listAppend += `<div class="wrapper-input_type list-name__Favorites">
      //     <input class="input-checkbox_field" type="checkbox" id="${thisElement.sectionId}-Favorites-${thisElement.dataset.productHandle}" value="Favorites" data-checked="false">
      //     <label class="label_heading" for="${thisElement.sectionId}-Favorites-${thisElement.dataset.productHandle}">Favorites</label>
      //   </div>`;
      // }
      wishlistObject.forEach(function (list) {
        let checked = list.exists ? "checked" : "";
        let isListExists = list.exists;
        if (checkProduct) {
          if (list.variantId && list.variantId.includes(selectedVariantId)) {
            checked = "checked";
            isListExists = true;
          } else {
            checked = "";
            isListExists = false;
          }
        }

        if (list.listName == "Favorites") {
          if (isListExists) {
            thisElement.querySelector(".wishlist-add__button.heart-favorites").classList.add("active");
          } else {
            thisElement.querySelector(".wishlist-add__button.heart-favorites").classList.remove("active");
          }
        }
        listAppend += `<div class="wrapper-input_type list-name__${list.listName}">
          <input class="input-checkbox_field" type="checkbox" id="${thisElement.sectionId}-${list.listName}-${list.productHandle}" value="${list.listName}" ${checked} data-checked="${isListExists}">
          <label class="label_heading" for="${thisElement.sectionId}-${list.listName}-${list.productHandle}">${list.listName}</label>
        </div>`;
      });
      if (listAppend) {
        thisElement.querySelector(".item-list_show").innerHTML = listAppend;
      }
    }
    thisElement.listInputChange();
  }
}

if (document.querySelector(".create-list-modal__popup")) {
  let popupElement = document.querySelector(".create-list-modal__popup");
  let popupElementClose = popupElement.querySelector(".cancle-modal-popup");
  let Segmentlist = document.querySelectorAll('.wishlist-add__button[data-type="list"]');
  let popupInputElement = popupElement.querySelector(".modal_input");
  let popupElementCount = popupElement.querySelector(".input_caracter_limit");
  let popupSubmitButton = popupElement.querySelector(".create-modal-popup");
  popupElementClose.addEventListener("click", function (button) {
    popupElement.classList.remove("active");
    Segmentlist.forEach((elementlist) => {
      elementlist.classList.remove("active");
    });
  });
  popupInputElement.addEventListener("input", function (event) {
    let popElementWordCount = popupInputElement.value.length;
    if (popElementWordCount && popupElementCount) {
      popupElementCount.innerHTML = popElementWordCount;
    }
    if (event.target.value.trim()) {
      popupSubmitButton.classList.remove("disabled");
    } else {
      popupSubmitButton.classList.add("disabled");
    }
  });
  popupSubmitButton.addEventListener("click", function (button) {
    let listName = popupInputElement.value;
    let customerId = popupElement.dataset.customerId;
    let variantId = popupElement.dataset.variantId;
    let productHandle = popupElement.dataset.productHandle;
    let loaderButton = popupElement.querySelector(".wishlist-loader");
    let VariantTitle = popupElement.dataset.variantTitle;
    let productTitle = popupElement.dataset.productTitle;

    if (loaderButton) {
      loaderButton.classList.add("is-loading");
    }
    if (listName.trim() != "") {
      let listObject = [
        {
          listName: listName,
          customerId: customerId,
          productHandle: productHandle,
          type: "create",
          variantId: variantId ? variantId : null,
          variantTitle: VariantTitle ? VariantTitle : null,
          productTitle: productTitle ? productTitle : null,
        },
      ];
      new Wishlist(listObject, '');
    }
  });
}

let customerId = document.body.dataset.customerId;
if (customerId) {

  fetch("https://mahacotizador.com/wishlist-app/fetch-wishlist-data.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ customerId: customerId })
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }).then((data) => {
    document.body.insertAdjacentHTML('beforeend', `<script id="wishlist-data" type="application/json">${JSON.stringify(data)}</script>`);
    customElements.define("wishlist-king", Wishlist);
    let navListAppend = document.querySelector(".nav-wishlist-list__data");
    let pageListAppend = document.querySelector(".page-wishlist-list__data");
    let mobileNavAppend = document.querySelector(".custom_mobile_nav");
    const listNames = data.map(item => item.list_name).filter(name => name);
    if (listNames.length > 0 && (navListAppend || pageListAppend || mobileNavAppend)) {
      const createListItem = (item, isMobile = false) => {
        if (isMobile) {
          const li = document.createElement('li');
          li.className = 'mobile-nav__item';
          li.innerHTML = `
            <div class="mobile-nav__child-item">
              <a href="/pages/wishlist-list?listName=${item}" class="mobile-nav__link">
                ${item}
              </a>
            </div>`;
          
          // setTimeout(() => {
          //   window.location.reload();
          // }, 500);
          return li;
        } else {
          const li = document.createElement('li');
          li.className = 'site-nav__dropdown-link tmenu_item_content_alignment_left';
          li.innerHTML = `<a href="/pages/wishlist-list?listName=${item}">${item}</a>`;
        
          return li;
        }
      };

      listNames.forEach(item => {
        if (navListAppend) {
          navListAppend.insertBefore(createListItem(item), navListAppend.firstChild);
        }
        if (pageListAppend) {
          pageListAppend.insertBefore(createListItem(item), pageListAppend.firstChild);
        }
        if (mobileNavAppend) {
          mobileNavAppend.insertBefore(createListItem(item, true), mobileNavAppend.firstChild);
        }
      });
    }
    if (window.location.href.indexOf("pages/wishlist-list") > -1) {
      wishlistPageInit();
    }
  })
  .catch((error) => {
    //alert("There was an error fetching the data. Please try again.");
    console.error("Error fetching data:", error);
  });
} else {
  customElements.define("wishlist-king", Wishlist);
}

async function wishlistPageInit() {
  let wishListData = document.getElementById('wishlist-data');
  let wishlistPage = document.querySelector('.wishlist-container');
  let urlParamter = new URLSearchParams(window.location.search);
  let listName = urlParamter.get("listName");
  let allListNav = wishlistPage.querySelector('.page-wishlist-list__data');
  if (allListNav) {
    let listItems = allListNav.querySelectorAll("li a");
    let activeSet = false;
    listItems.forEach(item => {
      if (item.textContent.trim() === listName) {
        item.classList.add("active_list");
        activeSet = true;
      } else {
        item.classList.remove("active_list");
      }
    });
    if (!activeSet && listItems.length > 0) {
      listItems[0].classList.add("active_list");
    }
  }

  if (wishListData) {
    let parseWishListData = JSON.parse(wishListData.innerHTML);
    if (parseWishListData.length > 0) {
      let listData = parseWishListData[0];
      let selectedListwrappers = wishlistPage.querySelectorAll('.selected-list__name');
      if (listName) {
        let filterListData = parseWishListData.filter(item => item.list_name === listName);
        if (filterListData.length) {
          listData = filterListData[0];
          //wishlistPage.querySelector('.selected-list__name').textContent = listName;
          selectedListwrappers.forEach(function(selectedListwrapper) {
            selectedListwrapper.textContent = listName;
          });
          wishlistPage.setAttribute('data-selected-list', listName);
        } else {
          //wishlistPage.querySelector('.selected-list__name').textContent = listData.list_name;
          selectedListwrappers.forEach(function(selectedListwrapper) {
            selectedListwrapper.textContent = listData.list_name;
          });
          wishlistPage.setAttribute('data-selected-list', listData.list_name);
        }
      } else {
        //wishlistPage.querySelector('.selected-list__name').textContent = listData.list_name;
        selectedListwrappers.forEach(function(selectedListwrapper) {
          selectedListwrapper.textContent = listData.list_name;
        });
        wishlistPage.setAttribute('data-selected-list', listData.list_name);
      }

      let products = JSON.parse(listData.product_handle);
      let productHandleArray = '';
      let productHandle = '';
      const productEntries = Object.values(products).filter((value) => value);
      const BATCH_SIZE = 10;
      let allProductItems = "";
      for (let i = 0; i < productEntries.length; i += BATCH_SIZE) {
        const batch = productEntries.slice(i, i + BATCH_SIZE);
        let batchHandleArray = "";

        for (const value of batch) {
          productHandle = value.productHandle;
          batchHandleArray += `__${value.productHandle}_${value.addedTime}${value.variantId ? "_" + value.variantId : ""}`;
        }

        const sectionUrl = `/products/${productHandle}/${batchHandleArray}/?section_id=wishlist-data`;

        try {
          const response = await fetch(sectionUrl);
          const responseText = await response.text();
          const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
          allProductItems += responseHTML.getElementById("sortable").innerHTML;
          
        } catch (error) {
          console.error("Error processing batch:", error);
        }
      }

      wishlistPage.querySelector("#sortable").innerHTML = allProductItems;
      wishlistPage.querySelector('.wishlist-item__loader').classList.add('hide');
      wishlistPage.querySelector('.add-to-cart').classList.remove('hide');
      wishlistPage.querySelector('.wishlist_checkout_btn').classList.remove('hide');
      wishlistPage.querySelector('.quantity_and_price_wrapper').classList.remove('hide');
      wishlistPage.querySelector('.downloadInvoiceBtn').classList.remove('hide');
      setTimeout(() => {
        const checkboxes = wishlistPage.querySelectorAll('.input-checkbox_field.single_products');
        checkboxes.forEach(checkbox => {
          const productId = checkbox.getAttribute('data-variant-id');
          const savedState = localStorage.getItem(`checkboxState-${productId}`);
          if (savedState === 'true') {
            checkbox.checked = true;
          } else {
            checkbox.checked = false;
          }
        });
        updateWishlistTotals();
      }, 200);


      if (productHandle) {
        // WISHLIST CONVERT
        function wishlist_convert() {
          let mainDownloadBtn = wishlistPage.querySelector(".downloadInvoiceBtn");
          wishlistPage.addEventListener("change", (event) => {
            if (event.target.classList.contains("single_products")) {
              const wishlistItems = wishlistPage.querySelectorAll(".wishlist-items-info");
              let isAnyChecked = Array.from(wishlistItems).some((item) => {
                const checkbox = item.querySelector(".single_products");
                return checkbox && checkbox.checked;
              });
            }
          });
          if (mainDownloadBtn) {
            mainDownloadBtn.addEventListener("click", () => {
              const wishlistItems = wishlistPage.querySelectorAll(".wishlist-items-info");
              mainDownloadBtn.classList.add('btn--loading');
              const productData = [];
              let isAnyChecked = false;

              wishlistItems.forEach((item) => {
                const checkbox = item.querySelector(".single_products");
                if (checkbox && checkbox.checked) {
                  isAnyChecked = true;
                }
              });

              wishlistItems.forEach((item) => {
                const checkbox = item.querySelector(".single_products");
                const isDisabled = checkbox?.disabled;

                if (isAnyChecked && (!checkbox || !checkbox.checked)) return;
                if (isDisabled) return;

                const quantityInput = item.querySelector(".js-qty__num");
                const imageElement = item.querySelector(".product_image img");
                const productPriceElement = item.querySelectorAll(
                  ".product_price .transcy-money"
                );
                const totalPriceElement = item.querySelector(
                  ".product_total_price .item-total__price .transcy-money"
                );
                const totalWeightElement = item.querySelector(
                  ".product_total_price .item-total__weight"
                );
                // console.log("totalWeightElement-", totalWeightElement);
                const product = {
                  quantity: quantityInput?.value || "0",
                  variantsku: item.querySelector(".variant_sku")?.innerText.trim() || "",
                  productDescription: item.querySelector(".product_main_title a")?.innerText.trim() || "",
                  variantDescription: item
                    .querySelector(".variant_title")
                    ?.innerText.replace("|", "").trim() || "",
                  imageSrc: imageElement?.getAttribute("src") || "",
                  uniteprice: productPriceElement[0]?.innerText.replace("$", "").trim() || "0.00",
                  mainDiscountPrice: productPriceElement[1]?.innerText.replace("$", "").trim() || "0.00",
                  basePrice: totalPriceElement?.innerText || "",
                  mainDiscount: 0,
                  price: totalPriceElement?.innerText.replace("$", "").trim() || "0.00",
                  shippingPrice: "0",
                  extraDiscount: "0.00",
                  shipping_title: "¡Envíos a todo México! (2 a 5 días hábiles) - Envío Gratis en compras mayores a $3,899",
                };

                productData.push(product);
              });
              let shippingPrice = 0; // default 0
              let shippingPriceWrapper = wishlistPage.querySelector('.shipping_price_wrapper .shipping_total_price');
              if(shippingPriceWrapper){
                let shippingPriceMain = shippingPriceWrapper.querySelector('.transcy-money');
                if (shippingPriceMain){
                  shippingPrice = parseFloat(shippingPriceMain?.innerText.replace("$", "").replace(",", "") || "0.00");
                }
              }
              const result = {
                type: {
                  product_data: productData,
                  customer_id: wishlistItems[0]?.getAttribute("data-customer-id") || "",
                  totalAmount: productData
                    .reduce((total, item) => {
                      const price = parseFloat(item.price.replace(",", ""));
                      return total + (isNaN(price) ? 0 : price);
                    }, 0)
                    .toFixed(2),
                    shippingPrice: shippingPrice,
                },
                ids: {},
              };

              // console.log(result);

              async function getData(url, data) {
                try {
                  const response = await fetch(url, {
                    method: "POST",
                    mode: "cors",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(data),
                  });

                  if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                  }
                  const text = await response.text();
                  // console.log("Raw Response:", text);
                  if (!text) {
                    throw new Error("Empty response from server");
                  }
                  const result = JSON.parse(text);

                  if (!result.url || !result.file_name) {
                    throw new Error(
                      "Invalid response structure: Missing 'url' or 'file_name'"
                    );
                  }
                  mainDownloadBtn.classList.remove('btn--loading');
                  const newTab = window.open(result.url, "_blank");
                  if (!newTab || newTab.closed || typeof newTab.closed == "undefined") {
                    window.location.href = result.url;
                  }

                } catch (error) {
                  mainDownloadBtn.classList.remove('btn--loading');
                  console.error("Fetch error:", error);
                }
              }

              getData(
                // "https://dev.shopifyexperthelp.com/mahahome/mahaHome_pdf",
                "http://mahacotizador.com/mahahome/mahaHome_pdf",
                result
              );
            });
          }
        }
        wishlist_convert();

        // for show price and quantity in list page 
        function updateWishlistTotals() {
          let totalQuantitydata = 0;
          let totalWeightdata = 0;
          let totalPricedata = 0;
          let subtotalPriceData = 0;

          let wishlistItemsdata = wishlistPage.querySelectorAll('.wishlist-items-info');
          let quantityShow = wishlistPage.querySelector('.total_quanity_wrapper .list_total_quantity');
          let priceShow = wishlistPage.querySelector('.total_price_wrapper .list_total_price');
          let subtotalShow = wishlistPage.querySelector('.subtotal_price_wrapper .list_subtotal_price');
          let weightShow = wishlistPage.querySelector('.total_price_wrapper .list_total_weight');
          let shippingPrice = wishlistPage.querySelector('.shipping_price_wrapper .shipping_total_price');
          let discountShow = wishlistPage.querySelector('.discount_price_wrapper .list_discount_price');

          // checkbox code
          let singleCheckboxes = wishlistPage.querySelectorAll('.input-checkbox_field.single_products');
          let checkedCheckboxes = Array.from(singleCheckboxes).filter(cb => cb.checked);

          
          if (checkedCheckboxes.length === 0) {
            if (quantityShow) quantityShow.innerHTML = "0";
            if (priceShow) priceShow.innerHTML = `$0.00 MXN`;
            if (weightShow) weightShow.innerHTML = `0`;
            if (subtotalShow) subtotalShow.innerHTML = `$0.00 MXN`;
            if (discountShow) discountShow.innerHTML = `$0.00 MXN`;
            if (shippingPrice) shippingPrice.innerHTML = `$0.00 MXN`;
            return; 
          }

          
          wishlistItemsdata.forEach((item) => {
            // console.log("wishlistItemsdata");
            if (item.classList.contains('disable_product_wrapper')) return;

            let relatedCheckbox = item.querySelector('.input-checkbox_field.single_products');
            if (!relatedCheckbox || !relatedCheckbox.checked) return;

            let quantityInputdata = item.querySelector('.js-qty__num');
            let productPriceElementdata = item.querySelector('.product_total_price .item-total__price .transcy-money:not(del .transcy-money)');
            let productWeightElementdata = item.querySelector('.product_total_price .item-total__weight');
            let delPriceElement = item.querySelector('.product_total_price .item-total__price del');
            let mainWeight = parseInt(productWeightElementdata?.innerText || "0");
            let mainQuantity = parseInt(quantityInputdata?.value || "0");
            let mainPrice = parseFloat(productPriceElementdata?.innerText.replace("$", "").replace(",", "") || "0.00");            
            let subPrice = parseFloat(delPriceElement?.innerText.replace("$", "").replace(",", "") || "0.00");

            if (isNaN(subPrice) || subPrice === 0) {
              subPrice = mainPrice;
            }
            totalQuantitydata += isNaN(mainQuantity) ? 0 : mainQuantity;
            totalWeightdata += !isNaN(mainWeight) ? mainWeight : 0;
            totalPricedata += !isNaN(mainPrice) ? mainPrice : 0;
            subtotalPriceData += !isNaN(subPrice) ? subPrice : 0;
            // console.log(totalQuantitydata +","+ totalWeightdata +","+ totalPricedata +","+ subtotalPriceData);
          });

          if (discountShow) {
            let discount = subtotalPriceData - totalPricedata;              
            discountShow.innerHTML = `$${discount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MXN`;
          }
          if (quantityShow) {
            quantityShow.innerHTML = totalQuantitydata;

            // quantity input set karo
            let qtyInput = document.querySelector('#cs_shipping_rate input[name="quantity1"]');
            if(qtyInput) {
              qtyInput.value = totalQuantitydata;
            }
          }
          if (subtotalShow) {
            subtotalShow.innerHTML = `$${subtotalPriceData.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MXN`;
          }
          if (weightShow) {
            weightShow.innerHTML = totalWeightdata ;
            let weightInput = document.querySelector('#cs_shipping_rate input[name="grams"]');
            console.log(weightInput);
            if(weightInput) {
              weightInput.value = totalWeightdata;
              let shipChkBtn = document.querySelector('#cs_shipping_rate #search_postcode');
              setTimeout(() => {
                shipChkBtn.click();
              }, 100);
            }
          }
          if (totalPricedata){
            let priceInput = document.querySelector('#cs_shipping_rate input[name="price"]');
            if(priceInput) {
              priceInput.value = totalPricedata;
            }
          }
          setTimeout(() => {
            if (priceShow) {
              if(shippingPrice){
                let shippingPriceMain = shippingPrice.querySelector('.transcy-money');
                if (shippingPriceMain){
                  let shipPrice = parseFloat(shippingPriceMain?.innerText.replace("$", "").replace(",", "") || "0.00");
                  totalPricedata += shipPrice;
                }
              }
              priceShow.innerHTML = `$${totalPricedata.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} MXN`;
            }
          }, 100);
          
          
        }

        updateWishlistTotals();
        window.updateWishlistTotals = updateWishlistTotals;


        // HULK APP DISCOUNT JSON
        const wishlistData = [];
        const wishlistPageJsonCrate = async () => {
          const wishlistItemList = wishlistPage.querySelectorAll(".wishlist-items-info");
          if (wishlistItemList.length === 0) return;
          const productRequests = Array.from(wishlistItemList).map(async (wishlistItem) => {
            const wlProductID = wishlistItem.getAttribute('data-product-id');
            const wlProductHandle = wishlistItem.getAttribute('data-handle');
            const wlProductVarID = wishlistItem.getAttribute('discount-variant-id');
            const responseData = await getDiscountedProduct(wlProductID, wlProductVarID);
            let hulkDiscount = [];

            // let wlVariantWeights = [];

            async function getWeights(productHandle, variantId){
              let res = await fetch(`/products/${productHandle}.js`);
              let product = await res.json();
              let variant = product.variants.find(v => v.id == variantId);
              if(variant) {
                return variant.weight
              }
            }

            let wlVariantWeights = await getWeights(wlProductHandle, wlProductVarID);


            if (responseData?.eligible_offer?.offer_levels) {
              hulkDiscount = JSON.parse(responseData.eligible_offer.offer_levels).map(offer => ({
                qty: offer[0],
                percent: parseFloat(offer[1])
              }));
            }

            // console.log('hulkDiscount - ',hulkDiscount);

            const getValue = (selector, attr = "textContent", defaultValue = "N/A") => {
              const element = wishlistItem.querySelector(selector);
              return element ? attr === "textContent" ? element.textContent.trim() : element.getAttribute(attr) || defaultValue : defaultValue;
            };

            if (hulkDiscount.length > 0) {
              return {
                customerId: wishlistItem.getAttribute("data-customer-id") || "Unknown Customer",
                productId: wlProductID || "Unknown Product ID",
                variantId: wlProductVarID || "Unknown Variant ID",
                variantWeights : wlVariantWeights || "Unknown Variant ID",
                title: wishlistItem.getAttribute("data-title") || "No Title",
                variantTitle: wishlistItem.getAttribute("data-variant-title") || "No Variant Title",
                price: getValue(".product_price", "data-price", "0"),
                quantity: getValue(".js-qty__num", "value", "1"),
                totalPrice: getValue(".product_total_price", "data-total-price", "0"),
                discount: hulkDiscount
              };
            } else {
              // console.log("No valid discount data available for this product.");
              return null;
            }
          });
          const results = await Promise.all(productRequests);
          wishlistData.push(...results.filter(item => item !== null));

          const jsonScript = `<script id="wishlist-page-response" type="application/json">${JSON.stringify(wishlistData)}</script>`;
          const existingScript = document.getElementById('wishlist-page-response');
          if (existingScript) {
            existingScript.innerHTML = JSON.stringify(wishlistData);
          } else {
            document.body.insertAdjacentHTML('beforeend', jsonScript);
          }
        };

        wishlistPageJsonCrate();

        async function getDiscountedProduct(productId, productVariants) {
          const url = `https://volumediscount.hulkapps.com/v1/products?product_id=${productId}&shop_domain=rafael-jjuan.myshopify.com${productVariants ? `&product_variants=${productVariants}` : ''}`;

          try {
            const response = await fetch(url, {
              method: "GET",
              headers: {
                "Authorization": "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJpc3N1ZXJfbmFtZSIsImF1ZCI6ImNsaWVudCIsInRva2VuX25hbWUiOiJnZXRfcmVzcG9uc2UiLCJzaG9wX2lkIjo2ODI5OCwiY3JlYXRlX3RpbWUiOiIyMDI1LTAxLTI4IDEwOjIyOjAyICswMDAwIn0.3DiZKuoe26tjfnVbYIpF3YTtPo9ibVP_1xKRrVORaZw",
                "Content-Type": "application/json"
              }
            });

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
            return await response.json();
          } catch (error) {
            console.error("Error fetching product data:", error);
            return null;
          }
        }

        function initializeWishlistSortable(wishlistPage) {
          const sortableList = wishlistPage.querySelector("#sortable");
      
          new Sortable(sortableList, {
            animation: 150,
            handle: ".product_drag_wrapper",
            onEnd: function (evt) {
              const allProducts = wishlistPage.querySelectorAll(".wishlist-items-info");
      
              // Update indexes in UI
              updateProductIndexes(allProducts);
      
              // Get the moved item (new position)
              const item = allProducts[evt.newIndex];
      
              const itemHandle = item.getAttribute('data-handle');
              const itemVarintid = item.getAttribute('data-selected-variant');
              const itemVariantTitle = item.getAttribute('data-variant-title');
              const itemcustomerId = item.getAttribute('data-customer-id');
              const itemselectedList = wishlistPage.getAttribute('data-selected-list');
              const productIndex = item.querySelector('.product_index').innerHTML;
      
              const itemObject = [{
                customerId: itemcustomerId,
                productHandle: itemHandle,
                listName: itemselectedList,
                variantId: itemVarintid || null,
                variantTitle: itemVariantTitle || null,
                productIndex: productIndex,
              }];
      
              // Send to server
              fetch('https://mahacotizador.com/wishlist-app/reorder.php', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(itemObject),
              })
              .then(response => response.json())
              .then(data => {
                // console.log('Server Response:', data);
              })
              .catch(error => {
                console.error('Error:', error);
              });
      
              // console.log('Moved item from', evt.oldIndex, 'to', evt.newIndex);
            }
          });
        }
      
        // Call the function with your wishlistPage reference
        initializeWishlistSortable(wishlistPage);

        // for popup delete single product

        let deleteListElements = wishlistPage.querySelectorAll('.delete-wishlist__item');
        let deleteProductPopup = wishlistPage.querySelector('.modal-popup.product-single-delete');
        let selectedDeleteItemData = null;
        if (deleteListElements) {
          deleteListElements.forEach(function name(deleteItem) {
            deleteItem.addEventListener('click', function () {
              selectedDeleteItemData = {
                customerId: deleteItem.dataset.customerId,
                productHandle: deleteItem.dataset.productHandle,
                variantId: deleteItem.dataset.selectedVariant,
                variantTitle: deleteItem.dataset.variantTitle
              };

              deleteProductPopup.classList.add("active");
            });
          })
        }
        let productCancelButton = deleteProductPopup.querySelector('.delete_product_cancle');
        if (productCancelButton) {
          productCancelButton.addEventListener('click', function () {
            deleteProductPopup.classList.remove('active');
            selectedDeleteItemData = null;
          });
        }


        let productConfirmButton = deleteProductPopup.querySelector('.delete_product_main_btn');
        if (productConfirmButton) {
          productConfirmButton.addEventListener('click', function () {
            if (!selectedDeleteItemData) return;

            productConfirmButton.classList.add('btn--loading');
            let selectedList = wishlistPage.dataset.selectedList;

            if (selectedList && selectedDeleteItemData.productHandle) {
              let listObject = [{
                customerId: selectedDeleteItemData.customerId,
                productHandle: selectedDeleteItemData.productHandle,
                listName: selectedList,
                type: "",
                variantId: selectedDeleteItemData.variantId || null,
                variantTitle: selectedDeleteItemData.variantTitle || null,
              }];

              new Wishlist(listObject, '');
            }

            selectedDeleteItemData = null;
            setTimeout ( function() {
              deleteProductPopup.classList.remove('active');
              productConfirmButton.classList.remove('btn--loading');  
            }, 1200);
          });
        }


        // Init wishlist items quantity
        wishlistPage.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: 'wishlist'
          });
        });

      // Checkbox select all product 
      let allProductCheckbox = wishlistPage.querySelector('.input-checkbox_field.all_products');
      let addButton = wishlistPage.querySelector('.add-to-cart');
      let addCheckoutButton = wishlistPage.querySelector('.wishlist_checkout_btn');

      allProductCheckbox.addEventListener('change', function () {
        let singleProductCheckboxes = wishlistPage.querySelectorAll('.input-checkbox_field.single_products');
        singleProductCheckboxes.forEach(checkbox => {
          const productId = checkbox.getAttribute('data-variant-id');
          localStorage.setItem(`checkboxState-${productId}`, checkbox.checked);
          let closeElement = checkbox.closest('.wishlist-items-info');
          if (!checkbox.hasAttribute('disabled')) {
            if (closeElement.classList.contains('hide')) {
              checkbox.checked = false;
            } else {
              checkbox.checked = allProductCheckbox.checked;
            }
          }
        });

        if (allProductCheckbox.checked) {
          addButton.removeAttribute('disabled');
          addCheckoutButton.removeAttribute('disabled');
        } else {
          addButton.setAttribute('disabled', true);
          addCheckoutButton.setAttribute('disabled', true);
        }

        // ✅ Update totals after select all
        updateWishlistTotals();
      });

      // ✅ Each single checkbox change pe bhi totals update
      let singleProductCheckboxes = wishlistPage.querySelectorAll('.input-checkbox_field.single_products');
      singleProductCheckboxes.forEach(cb => {
        cb.addEventListener('change', function () {
          updateWishlistTotals();
          const productId = cb.getAttribute('data-variant-id');
          localStorage.setItem(`checkboxState-${productId}`, cb.checked);
        });
      });


        // add to cart button enable select single product
        let singleCheckboxes = wishlistPage.querySelectorAll('.input-checkbox_field.single_products');
        let mainDownloadBtn = wishlistPage.querySelector(".downloadInvoiceBtn");
        singleCheckboxes.forEach(checkbox => {
          checkbox.addEventListener('click', (event) => {
            updateWishlistTotals();
            let allChecked = Array.from(singleCheckboxes).every(cb => cb.disabled || cb.checked);
            //allProductCheckbox.checked = allChecked;
            let anyChecked = Array.from(singleCheckboxes).some(cb => !cb.disabled && cb.checked);
            let svgIcon = `<span class="download_icon"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#ffffff" viewBox="0 0 256 256"><path d="M240,136v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V136a16,16,0,0,1,16-16H72a8,8,0,0,1,0,16H32v64H224V136H184a8,8,0,0,1,0-16h40A16,16,0,0,1,240,136Zm-117.66-2.34a8,8,0,0,0,11.32,0l48-48a8,8,0,0,0-11.32-11.32L136,108.69V24a8,8,0,0,0-16,0v84.69L85.66,74.34A8,8,0,0,0,74.34,85.66ZM200,168a12,12,0,1,0-12,12A12,12,0,0,0,200,168Z"></path></svg></span>`;
            if (anyChecked) {
              addButton.removeAttribute('disabled');
              addCheckoutButton.removeAttribute('disabled', true);
              mainDownloadBtn.innerHTML =  `${svgIcon} Descargar cotización seleccionada`;
            } else {
              addButton.setAttribute('disabled', true);
              addCheckoutButton.setAttribute('disabled', true);
              mainDownloadBtn.innerHTML = `${svgIcon} Descargar cotizacion`;
            }
          });
        });

        // Handle single product checkbox selection
        const handleSingleProductCheckboxes = () => {
          const singleProductCheckboxes = wishlistPage.querySelectorAll('.wishlist-items-info:not(.hide) .input-checkbox_field.single_products');
          const enabledCheckboxes = [...singleProductCheckboxes].filter((checkbox) => !checkbox.disabled);
          const allChecked = enabledCheckboxes.every((checkbox) => checkbox.checked);
          if (allProductCheckbox) {
            allProductCheckbox.checked = allChecked;
          }
        };
        // Attach event listener to single product checkboxes
        wishlistPage.addEventListener('change', (e) => {
          if (e.target.matches('.input-checkbox_field.single_products')) {
            handleSingleProductCheckboxes();
          }
        });

        // Search product based on product title
        const searchInput = wishlistPage.querySelector('.search-filter');
        let cartButton = wishlistPage.querySelector('.add-to-cart');
        let checkoutBtn = wishlistPage.querySelector('.wishlist_checkout_btn');
        let total_quantity_wpr = wishlistPage.querySelector('.quantity_and_price_wrapper');
        let emptyMessage = wishlistPage.querySelector('.empty_search_result.hide');
        let printButton = wishlistPage.querySelector('.downloadInvoiceBtn');
        if (searchInput) {
          searchInput.addEventListener('input', (e) => {
            const searchTerm = e.target.value.toLowerCase();
            const products = wishlistPage.querySelectorAll('.wishlist-items-info');
            const productIndex = wishlistPage.querySelectorAll('.product_index');
            let allHidden = true;
            products.forEach((product) => {
              const title = product.getAttribute('data-title').toLowerCase();
              const checkbox = product.querySelector('input[type="checkbox"]');
              product.setAttribute('draggable', false);
              if (title.includes(searchTerm)) {
                product.classList.remove('hide');
                allHidden = false;
              } else {
                product.classList.add('hide');
                if (checkbox && checkbox.checked) {
                  checkbox.checked = false;
                  if (cartButton) {
                    cartButton.setAttribute('disabled', true);
                  }
                  if (checkoutBtn) {
                    checkoutBtn.setAttribute('disabled', true);
                  }
                }
              }
            });
            if (searchTerm === '') {
              products.forEach((product) => {
                product.setAttribute('draggable', true);
                if (allProductCheckbox.checked) {
                  allProductCheckbox.checked = false;
                }
              });
            }
            if (allHidden) {
              emptyMessage.classList.remove('hide');
              cartButton.classList.add('hide');
              printButton.classList.add('hide');
              checkoutBtn.classList.add('hide');
              total_quantity_wpr.classList.add('hide');
            } else {
              emptyMessage.classList.add('hide');
              cartButton.classList.remove('hide');
              printButton.classList.remove('hide');
              checkoutBtn.classList.remove('hide');
              total_quantity_wpr.classList.remove('hide');
            }
            updateProductIndexes(products);
          });
        }

        // product indexing function 
        function updateProductIndexes(products) {
          let visibleCount = 0;
          products.forEach((product, index) => {
            let productIndexElement = product.querySelector('.product_index');
            if (product.classList.contains('hide')) {
              return;
            }
            visibleCount++;
            if (productIndexElement) {
              productIndexElement.textContent = visibleCount;
            }
          });
        }
        let productIndexchange = wishlistPage.querySelectorAll('.wishlist-items-info');
        updateProductIndexes(productIndexchange);

        // product shorting according to price and time
        const shortContainer = wishlistPage.querySelector(".sortable-list");
        const products = Array.from(shortContainer.querySelectorAll(".wishlist-items-info"));
        const sortDropdown = wishlistPage.querySelector("#sort-products");
        function sortProducts(order) {
          if (order === "default") return;
          let sortedProducts = [...products];
          if (order === "low-to-high" || order === "high-to-low") {
            sortedProducts.sort((a, b) => {
              const priceA = parseFloat(a.getAttribute("data-price"));
              const priceB = parseFloat(b.getAttribute("data-price"));
              return order === "low-to-high" ? priceA - priceB : priceB - priceA;
            });
          } else if (order === "newest-to-oldest" || order === "oldest-to-newest") {
            sortedProducts.sort((a, b) => {
              const timeA = parseInt(a.getAttribute("data-added-time"), 10);
              const timeB = parseInt(b.getAttribute("data-added-time"), 10);
              return order === "newest-to-oldest" ? timeB - timeA : timeA - timeB;
            });
          }
          shortContainer.innerHTML = "";
          sortedProducts.forEach(product => shortContainer.appendChild(product));
          updateProductIndexes(sortedProducts);
        }
        sortDropdown.addEventListener("change", function () {
          sortProducts(this.value);
        });

        // list product add to checkout
        // Lee los artículos marcados y convierte la cantidad a número. La cantidad ya viene
        // validada por <quantity-input> (respeta custom.minimum_quantity / custom.step_quantity);
        // aquí sólo se parsea y se descarta cualquier fila sin variante o sin cantidad usable.
        function collectSelectedWishlistItems() {
          const checked = wishlistPage.querySelectorAll('.input-checkbox_field.single_products:checked');
          const items = [];
          checked.forEach(function (checkbox) {
            const variantId = checkbox.getAttribute('data-variant-id');
            const parsedQty = parseInt(checkbox.getAttribute('data-selected-quantity'), 10);
            if (variantId && Number.isFinite(parsedQty) && parsedQty > 0) {
              items.push({ id: variantId, quantity: parsedQty });
            }
          });
          return items;
        }

        // Mensaje de error visible junto al botón. Se construye en JS con estilo propio para no
        // depender de CSS del tema ni introducir markup nuevo en el Liquid.
        function showWishlistCheckoutError(button, message) {
          let box = wishlistPage.querySelector('.wishlist-checkout-error');
          if (!box) {
            box = document.createElement('div');
            box.className = 'wishlist-checkout-error';
            box.setAttribute('role', 'alert');
            box.setAttribute('aria-live', 'assertive');
            box.style.cssText = 'margin-top:10px;padding:10px 12px;border-radius:8px;background:#fdecea;color:#8a1c11;border:1px solid #f5c6c0;font-size:14px;line-height:1.35;';
            if (button && button.parentNode) button.parentNode.insertBefore(box, button.nextSibling);
            else wishlistPage.appendChild(box);
          }
          box.textContent = message;
          box.hidden = false;
        }
        function clearWishlistCheckoutError() {
          const box = wishlistPage.querySelector('.wishlist-checkout-error');
          if (box) {
            box.hidden = true;
            box.textContent = '';
          }
        }

        let addToCheckoutButton = wishlistPage.querySelector('.wishlist_checkout_btn');
        if (addToCheckoutButton) {
          let checkoutInFlight = false; // evita doble clic y requests duplicados

          // Suelta el estado "en vuelo" si el cliente vuelve a esta página. Importante para el
          // regreso desde el checkout con el botón "atrás": el navegador puede restaurar la página
          // desde bfcache conservando el estado de JS, y sin esto el botón quedaría bloqueado.
          function releaseCheckoutLock() {
            checkoutInFlight = false;
            addToCheckoutButton.classList.remove('btn--loading');
            addToCheckoutButton.removeAttribute('aria-busy');
            addToCheckoutButton.disabled = false;
          }
          window.addEventListener('pageshow', releaseCheckoutLock);

          addToCheckoutButton.addEventListener('click', function (event) {
            event.preventDefault();
            if (checkoutInFlight) return;
            clearWishlistCheckoutError();

            const itemsToCheckout = collectSelectedWishlistItems();
            // CERO SELECCIONADOS: no se dispara ningún request y el carrito queda intacto.
            if (!itemsToCheckout.length) {
              showWishlistCheckoutError(addToCheckoutButton, 'Selecciona al menos un producto');
              return;
            }

            checkoutInFlight = true;
            addToCheckoutButton.classList.add('btn--loading');
            addToCheckoutButton.setAttribute('aria-busy', 'true');
            addToCheckoutButton.disabled = true;

            // Devuelve el botón a su estado normal para permitir reintentar. Nunca redirige.
            function finishWithError(message) {
              releaseCheckoutLock();
              showWishlistCheckoutError(addToCheckoutButton, message);
            }

            // Se AGREGA sobre el carrito existente. Ya NO se llama /cart/clear.js, así que los
            // artículos que el cliente ya tenía se conservan siempre, incluso si esto falla.
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({ items: itemsToCheckout }),
            })
              .then(function (response) {
                return response
                  .json()
                  .catch(function () { return null; })
                  .then(function (data) {
                    return { ok: response.ok, status: response.status, data: data };
                  });
              })
              .then(function (result) {
                if (!result.ok || (result.data && result.data.status === 422)) {
                  const serverMsg = result.data && (result.data.description || result.data.message);
                  finishWithError(
                    serverMsg
                      ? 'No pudimos agregar los productos: ' + serverMsg + ' Tu carrito no fue modificado.'
                      : 'No pudimos agregar los productos a tu carrito. Tu carrito no fue modificado. Intenta de nuevo.'
                  );
                  return;
                }
                // Sólo con la adición confirmada se avanza al checkout.
                window.location.href = '/checkout';
              })
              .catch(function (error) {
                console.error('Error al agregar los productos de la lista:', error);
                finishWithError('Ocurrió un problema de conexión. Tu carrito no fue modificado. Intenta de nuevo.');
              });
          });
        }

        // list product add to cart
        let addToCartButton = wishlistPage.querySelector('.add-to-cart');
        if (addToCartButton) {
          addToCartButton.addEventListener('click', function (event) {
            event.preventDefault();
            addToCartButton.classList.add('btn--loading');
            let checkedCheckboxes = wishlistPage.querySelectorAll('.input-checkbox_field.single_products:checked');
            let itemsToAdd = [];
            checkedCheckboxes.forEach(function (checkbox) {
              let variantId = checkbox.getAttribute('data-variant-id');
              let selectedQuantity = checkbox.getAttribute('data-selected-quantity');
              itemsToAdd.push({
                id: variantId,
                quantity: parseInt(selectedQuantity)
              });
            });
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({ items: itemsToAdd }),
            })
              .then(response => {
                //console.log('Raw response:', response); 
                return response.json();
              })
              .then(data => {
                addToCartButton.classList.remove('btn--loading');
                const event = new CustomEvent('cart:refresh', {
                  detail: { open: true }
                });
                document.dispatchEvent(event);
                if (data.status && data.status === 422) {
                  //console.error('Error adding products to cart:', data.message);
                } else {
                  // console.log('Items added to cart:', data);
                }
              })
              .catch(error => {
                console.error('Error adding items to cart:', error);
              });
          });
        }
      } else {
        if (wishlistPage.querySelector('.wishlist-items-info')) {
          wishlistPage.querySelector('.wishlist-items-info').remove();
        }
        wishlistPage.querySelector('.wishlist-item__loader').classList.add('hide');
        wishlistPage.querySelector('.empty-wishlist__items').classList.remove('hide');
        wishlistPage.querySelector('.add-to-cart').classList.add('hide');
        wishlistPage.querySelector('.wishlist_checkout_btn').classList.add('hide');
        wishlistPage.querySelector('.quantity_and_price_wrapper').classList.add('hide');
        wishlistPage.querySelector('.downloadInvoiceBtn').classList.add('hide');
      }
    } else {
      if (wishlistPage.querySelector('.wishlist-items-info')) {
        wishlistPage.querySelector('.wishlist-items-info').remove();
      }
      wishlistPage.querySelector('.wishlist-item__loader').classList.add('hide');
      wishlistPage.querySelector('.empty-wishlist__items').classList.remove('hide');
    }
    wishlistPage.querySelectorAll(".list_troggle").forEach(button => {
      button.addEventListener('click', function () {
        const dropdown = this.nextElementSibling;
        if (dropdown) {
          this.classList.toggle("open");
          dropdown.classList.toggle("active");
        }
      });
    });

    let popupOverlay = document.querySelector(".modal-popup.create-list-modal__popup");
    wishlistPage.querySelector(".page-list-create").addEventListener("click", function () {
      popupOverlay.classList.add("active");
    });

    // let deleteList = wishlistPage.querySelector('.delete-list-button');
    // if (deleteList) {
    //   deleteList.addEventListener('click', function () {
    //     deleteList.classList.add('btn--loading');
    //     let selectedList = wishlistPage.dataset.selectedList;
    //     if (selectedList) {
    //       let listObject = [{
    //         listName: selectedList,
    //         customerId: customerId,
    //         type: "delete"
    //       },
    //       ];
    //       new Wishlist(listObject, '');
    //     }
    //   });
    // }


    let deleteList = wishlistPage.querySelector('.delete-list-button');
    let ModelDeleteActive = wishlistPage.querySelector('.modal-popup.product-list-delete')
    if (deleteList) {
      deleteList.addEventListener('click', function () {
        ModelDeleteActive.classList.add('active');
      });
    }
    let modelDeleteCancle = wishlistPage.querySelector('.delete_list_cancle');
    if (ModelDeleteActive) {
      modelDeleteCancle.addEventListener('click', function () {
        ModelDeleteActive.classList.remove('active');
      });
    }
    let modalDeleateList = wishlistPage.querySelector('.delete_list_main_btn');
    if (modalDeleateList) {
      modalDeleateList.addEventListener('click', function () {
        modalDeleateList.classList.add('btn--loading');
        let selectedList = wishlistPage.dataset.selectedList;
        if (selectedList) {
          let listObject = [{
            listName: selectedList,
            customerId: customerId,
            type: "delete"
          },
          ];
          new Wishlist(listObject, '');
        }
      });
    }

  }
}
